var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToriiGate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 128C497.625 128 512 113.625 512 96V0C469.875 21 423.5 32 376.5 32H135.5C88.5 32 42.125 21 0 0V96C0 113.625 14.375 128 32 128H64V192H16C7.125 192 0 199.125 0 208V240C0 248.875 7.125 256 16 256H64V496C64 504.875 71.125 512 80 512H112C120.875 512 128 504.875 128 496V256H384V496C384 504.875 391.125 512 400 512H432C440.875 512 448 504.875 448 496V256H496C504.875 256 512 248.875 512 240V208C512 199.125 504.875 192 496 192H448V128H480ZM224 192H128V128H224V192ZM384 192H288V128H384V192Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToriiGate);
export default __webpack_public_path__ + "static/media/torii-gate.855eea01f19217ef59fc4534ae1cdac8.svg";
export { ForwardRef as ReactComponent };